import type {QueryClient} from '@tanstack/react-query'

import {workerKeys} from 'src/assets/workers/query-keys'

/** Drop cached worker/rental-asset assignment strips after job schedule or assignment changes. */
export function invalidateResourceAssignmentQueries(queryClient: QueryClient) {
    void queryClient.invalidateQueries({queryKey: workerKeys.allAssignments()})
    void queryClient.invalidateQueries({
        predicate: (query) =>
            query.queryKey[0] === 'rental-assets' && query.queryKey[2] === 'assignments',
    })
}
